/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { Icon, View } from '@components/atoms'
import { PanelResizeHandle, PanelResizeHandleProps } from 'react-resizable-panels'

import { grey } from '@mui/material/colors'

export const ResizableHandle = (props: PanelResizeHandleProps) => {
	return (
		<PanelResizeHandle {...props} css={style}>
			<View className="resizableHanbleInnerView">
				<Icon name="arrow-split-vertical" className="resizableHandelIcon" />
			</View>
		</PanelResizeHandle>
	)
}

const style = css({
	flex: '0 0 1.5em',
	position: 'relative',
	outline: 'none',

	'&[data-resize-handle-active]': {
		backgroundColor: grey[200],
	},

	'.resizableHanbleInnerView': {
		position: 'absolute',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		top: '0.25em',
		bottom: '0.25em',
		left: '0.25em',
		right: '0.25em',
		borderRadius: '5px',
		backgroundColor: grey[100],
		transition: 'background-color 0.2s linear',

		'.resizableHandelIcon': {
			color: grey[500],
		},
	},
})
